import React, { useContext, useEffect, useRef, useState } from "react";
import "./CtaCorriente.css";
import CtaCorrienteList from "../../components/ctaCorrienteList/CtaCorrienteList.js";
import DropdownSelect from "../../components/dropdownSelect/DropdownSelect.js";
import {
  getCuentasCorrientesByNroCta,
  deleteAndGetCuentasCorrientesByNroCtaFromSoftland,
} from "../../api/cuentaCorriente.js";
import SelectList from "../../components/SelectList/SelectList.js";

//Util
import { getDateStringYYYYMMDD } from "../../utils/formatDate.js";

//Contexts
import authContext from "../../context/authentication/authContex.js";
import proveedoresContext from "../../context/proveedores/proveedoresContext.js";

// Alertas
import Swal from "sweetalert2";

//Permisos
import { ACTUALIZAR_MOVIMIENTOS_PROVEEDOR } from "../../utils/permisos";

const CtaCorriente = () => {
  const hoy = new Date().toISOString().split("T")[0]; // 'YYYY-MM-DD'
  const [filtros, setFiltros] = useState({
    fchdes: "1980-01-01",
    fchhas: getDateStringYYYYMMDD(),
  });
  const [orderBy, setOrderBy] = useState("Fecha");
  const optionsOrder = [
    { label: "Fecha", value: "date" },
    { label: "Titulo", value: "title" },
  ];
  const [order, setOrder] = useState("desc");
  const [list, setList] = useState([]);
  const [provider, setProvider] = useState({});
  const ascCheck = useRef("");
  const descCheck = useRef("");

  const aContext = useContext(authContext);
  const { usuario } = aContext;

  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;

  useEffect(() => {
    const fn = async () => {
      if (usuario.nroCta) {
        await obtenerCuentasCorrientesByNroCta();
      } else {
        await actualizarProveedores();
      }
    };
    fn();
  }, []);

  const obtenerCuentasCorrientesByNroCta = async () => {
    try {
      const resp = await getCuentasCorrientesByNroCta(usuario.nroCta);
      setList(resp.data.data);
    } catch (error) {
      console.error("Error al obtener cuentas corrientes:", error);
    }
  };

  const actualizarMovimientosSegunProveedor = async () => {
    Swal.fire({
      title: `Desea actualizar los movimientos del proveedor ${provider.nroCta} - ${provider.nombre}?`,
      text: "Se traeran los datos de Softland para sobreescribir los movimientos de cuenta corriente del proveedor seleccionado.",
      showCancelButton: true,
      confirmButtonText: "Actualizar",
      cancelButtonText: "No, cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteAndGetCuentasCorrientesByNroCtaFromSoftland(
          provider.nroCta
        )
          .then((response) => {
            if (!response.status) {
              throw new Error(response.msg);
            }
            return response;
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        setList(result.value.data.data);
        Swal.fire(
          "Actualizado!",
          "La base de datos ha sido actualizada correctamente.",
          "success"
        );
      }
    });
  };

  const handleChange = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const handleClickCheck = (e) => {
    if (e.target.name == "descOrder") {
      if (ascCheck.current.checked) ascCheck.current.checked = false;
      setOrder("desc");
    } else {
      if (descCheck.current.checked) descCheck.current.checked = false;
      setOrder("asc");
    }
  };

  const handleChangeProveedor = async (value) => {
    const proveedorSeleccionado = proveedores.find(
      (p) =>
        `${p.nroCta}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (proveedorSeleccionado !== undefined) {
      setProvider(proveedorSeleccionado);
    }

    const resp = await getCuentasCorrientesByNroCta(
      proveedorSeleccionado.nroCta
    );
    setList(resp.data.data);
  };

  return (
    <div className="ctaCorrienteDiv">
      <div className="asideFiltros">
        {usuario.userType.some((item) =>
          ACTUALIZAR_MOVIMIENTOS_PROVEEDOR.includes(item.typeName)
        ) && (
          <SelectList
            text={"Proveedor:"}
            options={proveedores.map((p) => {
              return {
                value: `${p.nroCta}`,
                label: `${p.nroCta} - ${p.nombre}`,
              };
            })}
            handleChange={handleChangeProveedor}
            property={"Proveedor"}
            valueAux={{
              label:
                provider.nombre && provider.nroCta
                  ? `${provider.nroCta} - ${provider.nombre}`
                  : "Seleccione...",
              value: provider.nroCta || "",
            }}
            emptyInputs={[]}
            styles={{
              additionalStyleDivSelectList: {
                alignItems: "center",
                gap: "0.5rem",
              },
              fontStyleTitle: {
                fontSize: "1.5rem",
              },
            }}
          />
        )}
        <div className="inputGroup">
          <label>Fecha desde:</label>
          <input
            name="fchdes"
            type="date"
            defaultValue="1980-01-01"
            onChange={(e) => handleChange(e)}
          ></input>
        </div>
        <div className="inputGroup">
          <label>Fecha hasta:</label>
          <input
            name="fchhas"
            type="date"
            defaultValue={getDateStringYYYYMMDD()}
            onChange={(e) => handleChange(e)}
          ></input>
        </div>
        <div className="inputGroup">
          <label>Ordenar por...</label>
          <DropdownSelect
            options={optionsOrder}
            setFilter={setOrderBy}
            onlySelectFunction={true}
            placeholder="Fecha"
          />
          <div className="setOrderDiv">
            <div className="inputGroup">
              <label>Asc</label>
              <input
                name="ascOrder"
                ref={ascCheck}
                type="checkbox"
                onClick={(e) => handleClickCheck(e)}
              />
            </div>
            <div className="inputGroup">
              <label>Desc</label>
              <input
                name="descOrder"
                defaultChecked
                ref={descCheck}
                type="checkbox"
                onClick={(e) => handleClickCheck(e)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="resultadosDiv">
        {usuario.userType.some((item) =>
          ACTUALIZAR_MOVIMIENTOS_PROVEEDOR.includes(item.typeName)
        ) && (
          <button
            className={`actualizar-providers-btn ${
              !provider?.nroCta ? "disabled-btn" : ""
            }`}
            style={{
              marginLeft: "auto",
              marginTop: "-55px",
              display: "block",
            }}
            onClick={
              !provider?.nroCta ? null : actualizarMovimientosSegunProveedor
            }
          >
            Actualizar Movimientos
          </button>
        )}
        <CtaCorrienteList
          fchdes={filtros.fchdes}
          fchhas={filtros.fchhas}
          orderBy={orderBy}
          order={order}
          list={list}
        />
      </div>
    </div>
  );
};

export default CtaCorriente;